import { render, staticRenderFns } from "./comp-room-name.vue?vue&type=template&id=69743bd5&scoped=true&lang=pug&"
import script from "./comp-room-name.vue?vue&type=script&lang=js&"
export * from "./comp-room-name.vue?vue&type=script&lang=js&"
import style0 from "./comp-room-name.vue?vue&type=style&index=0&id=69743bd5&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69743bd5",
  null
  
)

/* custom blocks */
import block0 from "./comp-room-name.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports